import "../../assets/index6.css";
import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { m as p } from "../../chunks/make-refs.cb0b9b76.js";
import { c as f } from "../../chunks/index.bddf5ebb.js";
import { forwardRef as h } from "react";
const u = "_card_19wcm_1", w = "_picture_19wcm_34", I = "_image_19wcm_53", x = "_hasImage_19wcm_59", t = {
  card: u,
  picture: w,
  image: I,
  hasImage: x
}, C = h(
  ({ children: s, className: i, imgProps: a = {}, imgSources: e, ...l }, d) => {
    const { $el: _ } = p(d, ["$el"]), m = () => a.src && /* @__PURE__ */ r("picture", { className: t.picture, children: [
      e == null ? void 0 : e.map((n) => /* @__PURE__ */ o("source", { ...n }, n.srcSet)),
      /* @__PURE__ */ o(
        "img",
        {
          className: t.image,
          loading: "lazy",
          ...a.alt ? { alt: a.alt } : { "aria-hidden": !0 },
          ...a
        }
      )
    ] }), c = {
      ref: _,
      className: f([i, t.card], {
        [t.hasImage]: !!a.src
      }),
      ...l
    };
    return "href" in c ? /* @__PURE__ */ r("a", { ...c, children: [
      m(),
      s
    ] }) : /* @__PURE__ */ r(
      "button",
      {
        type: "button",
        ...c,
        children: [
          m(),
          s
        ]
      }
    );
  }
);
export {
  C as Card
};
//# sourceMappingURL=index.js.map
